import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const MEASUREMENT_ID = 'G-DVDB9RR0JP';

ReactGA.initialize(MEASUREMENT_ID);

export default function Analytics() {
	const location = useLocation();

	useEffect(() => {
		ReactGA.send({
			hitType: 'pageview',
			page: location.pathname + location.search,
		});
	}, [location]);

	return null;
}
